var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseCorrelationInfoTitle"},[_vm._t("img"),_vm._t("text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }